import { DataSynthesis } from "@/types/generated/UsedGeneratedTypes";

export interface ReferenceObject {
  label?: string;
  [key: string]: any;
}

/**
 * Renvoie le nombre de lignes pour un type de référence donné (ou 0 par défaut).
 * @param referenceSynthesis Liste d'objets de synthèse {referenceType, lineCount}
 * @param ref Objet référence (avec label) ou string label
 */
export function lineCountSynthesis(
  referenceSynthesis: DataSynthesis[] | undefined,
  ref: ReferenceObject | string,
): number {
  if (referenceSynthesis) {
    for (let i = 0; i < referenceSynthesis.length; i++) {
      const refType = referenceSynthesis[i].referenceType;
      if (typeof ref === "object" && refType === ref.id) {
        return referenceSynthesis[i].lineCount;
      }
      else if (typeof ref === "string" && refType === ref) {
        return referenceSynthesis[i].lineCount;
      }
    }
  }
  return 0;
}
